import React, { useState } from "react";
import { Button, Dialog, DialogContent } from "@mui/material";
import { Stack, styled, TextField, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { updateEntryDetails } from "./httpCalls";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Loader from "../components/Loader";

const ButtonCancel = styled(Button)({
  backgroundColor: "#999999",
  color: "#fff",
  "&:hover": {
    backgroundColor: "#6b6b6b",
  },
});

function EditEntry({ record, onClose, open, onSuccess }) {
  const history = useHistory();
  const { type, selected } = useSelector((state) => state.ledger);
  const [state, setState] = useState({
    loading: false,
    new: 0,
    detail: record.detail,
    totalAmount: record.totalAmount || 0,
    depositedAmount: record.depositedAmount,
    remainingAmount: record?.remainingAmount,
    srNum:record?.srNum,
    ledgerId:record?.ledgerId
  });
  console.log('rec', record)
  const handleSubmit = async () => {
    try {
      if (state.detail == "") {
        toast.configure();
        toast.info("Ledger Detail cannot be empty");
        return;
      }
      // if (state.totalAmount == 0) {
      //   toast.configure();
      //   toast.info("Ledger Detail cannot be empty");
      //   return;
      // }
      setState((prev) => ({ ...prev, loading: true }));
      // let rem = state.remainingAmount ? state.remainingAmount : 0;
      // let deposited = state.depositedAmount ? state.depositedAmount : 0;
      // let newAmount = state.new ? state.new : 0;
      // let remaining = parseInt(rem) - parseInt(newAmount);
      // let dep = parseInt(deposited) + parseInt(newAmount);
      // let copy = JSON.parse(JSON.stringify(selected));
      // let found = copy[type].find((item) => item.srNum == record.srNum);
      // if (found) {
      //   found.remainingAmount = remaining;
      //   found.detail = state.detail;
      //   found.new_depositedAmount = newAmount;
      //   found.depositedAmount = dep;
      //   found.totalAmount = state.totalAmount;

        await updateEntryDetails(state, record.srNum, type, history);
        setState((prev) => ({ ...prev, loading: false }));
        toggle();
        onSuccess();
      // } else {
      //   toast.configure();
      //   toast.info("Ledger Type Not Found");
      //   onSuccess();
      // }
    } catch (error) {
      console.log(error);
      toast.configure();
      toast.error("Error");
      onSuccess();
    }
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    console.log('remaining', value)
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const toggle = () => {
    if (!state.loading) {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={toggle} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack direction="column" spacing={2}>
          <Typography
            variant="h6"
            sx={{ textAlign: "center", color: "#4EAF51" }}
          >
            Edit Ledger Entry
          </Typography>
          <TextField
            autoFocus
            size="small"
            label="Name"
            fullWidth
            name="detail"
            value={state.detail}
            onChange={handleChange}
          />
          <TextField
            size="small"
            type="number"
            label="Total Amount"
            fullWidth
            name="totalAmount"
            value={state.totalAmount}
            onChange={handleChange}
          />
          <TextField
            size="small"
            type="number"
            label="Deposited Amount"
            fullWidth
            name="depositedAmount"
            value={state.depositedAmount}
            onChange={handleChange}
          />
          {/* <TextField
            autoFocus
            size="small"
            label="New Deposit"
            type="number"
            name="new"
            fullWidth
            value={state.new}
            onChange={handleChange}
          /> */}
          <TextField
            size="small"
            label="Remaining Amount"
            type="number"
            name="remainingAmount"
            fullWidth
            value={(state.totalAmount) - (state.depositedAmount)}
            onChange={handleChange}
          />
          {!state.loading && (
            <Stack direction="row" justifyContent="center" spacing={3}>
              <Button variant="contained" onClick={handleSubmit}>
                Update
              </Button>
              <ButtonCancel onClick={toggle}>Cancel</ButtonCancel>
            </Stack>
          )}
          {state.loading && (
            <Stack direction="row" justifyContent="center" spacing={3}>
              <Loader loading={state.loading} />
            </Stack>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default EditEntry;
